<template>
  <div class="stepper">
    <ul>
      <li
          v-for="(step) of steps" :key="step.id"
          v-bind:class="getClass(step)"
          @click="step.locked?'':goToStep(step.id)"
      >
        <span class="step-img" v-if="step.image"><img :alt="$t(step.title)" :src="getSrc(step.image)"/></span>
        {{ $t(step.title) }}
        <span v-if="step.help">
            <help-tooltip :tooltipText="step.help"></help-tooltip>
        </span>
      </li>
      <li class="empty-end">&nbsp;</li>
    </ul>
  </div>
</template>

<script>
import imageMixin from '../mixins/image'
import HelpTooltip from '@/components/HelpTooltip'

export default {
  name: 'Stepper',
  components: {HelpTooltip},
  props: ['steps'],
  mixins: [imageMixin],
  methods: {
    goToStep(id)
    {
      this.$emit('setstep', id)
    },
    getClass(step)
    {
      let statusClass = ''
      statusClass += step.active ? 'active ' : (step.completed ? ' completed ' : '')
      statusClass += step.locked ? ' locked ' : ''
      return statusClass
    }
  }
}
</script>
<style lang="scss" scoped>

ul {
  padding-inline-start: 0;
  width: 100%;
  display: inline-flex;
}

@media (max-width: 510px) {
  ul {
    display: inline-grid;
  }
}

ul > li {
  display: inline-block;
  zoom: 1;
  *display: inline;
  padding-right: 25px;
  padding-left: 5px;
  border-bottom: 3px solid #EDEFF2;
  white-space: nowrap;
  cursor: pointer;
}

.stepper {
  width: 100%;
  display: block;
  margin: 20px auto 20px 3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}

.active {
  a {
    color: #30A7FE;
    text-decoration: none;
  }

  font-weight: bold;
  border-bottom: 3px solid #30A7FE;
}

.completed {
  opacity: 0.4;
  color: #30A7FE;
  border-bottom: 3px solid #30A7FE;
}

.locked {
  opacity: 0.8;
  color: #c3c3c3;
}

.empty-end {
  width: 100%;
  overflow: auto;
  display: inline;
  cursor: default;
}

.help{
  width: 12px;
  vertical-align: text-top;
}
.step-img img {
  width: 20px;
  vertical-align: text-top;
}
</style>
